<template>
  <div :class="['relative', 'grid lg:grid-cols-2 grid-cols-1']">
    <!-- 左侧容器 -->
    <div :class="['size-full overflow-hidden', 'lg:static absolute']">
      <Motion
        :initial="{ opacity: 0, x: -120 }"
        :while-in-view="{ opacity: 1, x: 0 }"
        :transition="{
          type: 'spring',
          stiffness: 20,
          damping: 10,
        }"
        :in-view-options="{
          once: true,
        }"
        class="size-full"
      >
        <!-- 图片 -->
        <NuxtImg
          src="/img/about/brand.webp"
          :class="[
            'size-full',
            'hover:scale-105 transition-[scale] duration-1000',
            'lg:brightness-100 brightness-70',
            'object-cover',
          ]"
        />
      </Motion>
    </div>

    <!-- 右侧容器 -->
    <div
      :class="[
        'relative',
        'size-full min-h-120',
        'lg:p-24 px-4 py-24',
        'text-white text-shadow-lg',
        // 渐变遮挡块
        'before:absolute before:top-0',
        'before:bg-secondary before:h-full',
        'before:w-60 before:-left-60',
        'before:mask-l-from-0% before:mask-l-to-50%',
        'before:lg:block before:hidden',
      ]"
    >
      <div
        :class="[
          'flex flex-col justify-center lg:items-start items-center lg:gap-8 gap-6',
          'size-full',
        ]"
      >
        <CommonBanner
          title="Crystal Logistics Group"
          :content="t('page.index.infoBrand.desc')"
          :centered="false"
          :has-padding="false"
          theme="dark"
        />

        <CommonBtnPress
          :label="t('page.index.infoBrand.seeBrand')"
          :type="2"
          tralling-icon="fe:arrow-right"
          @click="useLocalePush('/about/brand')"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
  const { t } = useI18n()
</script>
